module.exports = __webpack_public_path__ + "img/Weapon_283.ef002d3c.png";